// Centralized app route definitions and path builders
// Use these constants in <Route path> and for navigation to avoid typos
export const ROOT = '/';
export const LOGIN = '/login';
export const LOGIN_CONSENT = '/login/consent';
export const LIBRARY = '/library';
// Route patterns with parameters
export const OWNER = '/o/:musicOwner';
// Route pattern for title exploration (class + lingo)
export const CLASS = '/c/:titleClass/:titleLingo';
export const VIDEO = '/v/:musicVideo';
// Informational pages
export const TOS = '/tos';
export const PRIVACY = '/privacy';
export const ABOUT = '/about';
export const ACCOUNT = '/account';

// Path builders for dynamic navigation
export function ownerPath(musicOwner: string): string {
  return `/o/${musicOwner}`;
}

export function videoPath(musicVideo: string): string {
  return `/v/${musicVideo}`;
}

export function classPath(titleLingo: string,
                          titleClass: string): string {
  return `/c/${encodeURIComponent(titleClass)}/${encodeURIComponent(titleLingo)}`;
}